import LabServiceModel from "@/models/LabServiceModel";
import TestPackageModel from "./TestPackageModel";

export default class SampleModel extends LabServiceModel {
  modelName() {
    return "quality-control";
  }
  icon() {
    return "pencil";
  }
  defaults() {
    return {
      id: null,
      test_package_id: null,
      schedulable_task_type: null,
      schedulable_task_id: null,
      laboratory_id: null,
      name: null,
      sheet_label: null,
      description: null,
      interval: null,
      interval_index: null,
    };
  }
  mutations() {
    return {
        id: (val) => this.nullStringMutator(val),
        test_package_id: (val) => this.nullStringMutator(val),
        schedulable_task_type: (val) => this.nullStringMutator(val),
        schedulable_task_id: (val) => this.nullStringMutator(val),
        laboratory_id: (val) => this.nullStringMutator(val),
        name: (val) => this.nullStringMutator(val),
        sheet_label: (val) => this.nullStringMutator(val),
        description: (val) => this.nullStringMutator(val),
        interval: (val) => this.nullStringMutator(val),
        interval_index: (val) => this.nullStringMutator(val),
        created_at: (val) => this.nullStringMutator(val),
        updated_at: (val) => this.nullStringMutator(val),
        deleted_at: (val) => this.nullStringMutator(val),
    };
  }
  validation() {
    return {};
  }
  getTestPackage() {
    return this.getRelatedModel(TestPackageModel, 'test_package');
  }
}
